import { CalendarDate, parseDate } from "@internationalized/date";

export const isoToDateValue = (iso: string | null): CalendarDate | null => {
    if (!iso) {
        return null;
    }
    try {
        return parseDate(iso);
    } catch {
        return null;
    }
};

export const dateValueToIso = (value: CalendarDate | null): string | null => {
    if (!value) {
        return null;
    }
    return value.toString();
};
